/**
 * Copyright 2013-present, Novivia, Inc.
 * All rights reserved.
 */

import _ from "lodash";
import {__} from "language";
import {formats} from "@auex/utilities";

const {number} = formats;


// FIXME: Importing doesn't work because of the front-end short-circuit in that
// module.
const auexConfigurations = require("@auex/configurations");

export function getAlternateCurrencies(currentCurrency) {
  const upperCurrentCurrency = currentCurrency.toUpperCase();

  return auexConfigurations.paymentCurrencies.filter(
    currency => currency !== upperCurrentCurrency,
  );
}

export function getAccountingSettings(currency) {
  return _.merge(
    {},
    number.getAccountingSettings(currency && currency.toUpperCase()),
    __("language::accounting"),
  );
}

export function formatMoney(amount, currency) {
  return number.formatMoney({
    amount,
    settings: getAccountingSettings(currency).currency,
  });
}



// WEBPACK FOOTER //
// ../currency.js